export enum FormulaSequenceStatus {
    Live = 'Live',
    Draft = 'Draft',
    Archived = 'Archived',
}

export enum FormulaSequenceKeys {
    Status = 'status',
    Tags = 'tags',
    Audience = 'audience',
    CompoundTrigger = 'compound_trigger',
}
